import { Button, Modal } from 'antd';

import './ExperienceSwitchModal.scss';

type ExperienceSwitchModalProps = {
  open: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
};

export const ExperienceSwitchModal = ({
  open,
  onSave,
  onDiscard,
  onCancel,
}: ExperienceSwitchModalProps) => {
  return (
    <Modal
      className="experience-switch-modal"
      open={open}
      onCancel={onCancel}
      footer={
        <div className="custom-footer">
          <Button onClick={onCancel}>Cancel</Button>

          <div className="right-buttons">
            <Button onClick={onDiscard}>Discard & Switch</Button>
            <Button type="primary" onClick={onSave}>
              Save & Switch
            </Button>
          </div>
        </div>
      }
      closable
      title="Unsaved Changes"
    >
      You have unsaved changes. Do you want to save before switching tabs?
    </Modal>
  );
};
